const de = {
  title: 'Meine Rechnungen',
  invoiceTitle: 'Rechnung',
  cancelledInvoiceTitle: 'Stornorechnung',
  invoiceNumber: 'Rechnungsnummer',
  bookingCode: 'Buchungskennzeichen',
  creator: 'Ersteller',
  customers: {
    title: 'Kunden'
  },
  downloadBulkImportTemplate: 'Massenimport Vorlage',
  createInvoice: 'Rechnung erstellen',
  approveInvoice: 'Rechnung freigeben',
  approveManual: 'Rechnung manuell freigeben',
  denyInvoice: 'Rechnung ablehnen',
  deleteInvoice: 'Rechnung löschen',
  cancelInvoice: 'Rechnung stornieren',
  toCancelledInvoice: 'Zur Stornorechnung',
  toOriginalInvoice: 'Zur OriginalRechnung',
  openInDMS: 'In DMS öffnen',
  editInvoice: 'Rechnung bearbeiten',
  newArticle: 'Neue Rechnungsposition',
  articleName: 'Artikelname',
  importInvoices: 'Rechnungen importieren',
  importInvoicesLoading: 'Die Rechnungen werden hochgeladen...',
  importInvoicesLoading2: 'Bitte haben Sie einen Moment Geduld.',
  states: {
    draft: 'Entwurf',
    open: 'Bereit',
    incomplete: 'Unvollständig',
    approved: 'Genehmigt',
    denied: 'Abgelehnt',
    archived: 'Archiviert',
    cancelled: 'Storniert',
    final: 'Übermittelt'
  },
  validation: {
    reminderKey: 'Der Mahnschlüssel muss bei STOK entweder 13 oder 14 sein',
    costBearer: 'Eines von beiden Feldern muss ausgefüllt sein: Kostenträger, Kostenstelle',
    missingFields: 'Die Rechnung ist unvollständig. Es müssen noch Felder ausgefüllt werden.',
    onlyNumbersLeadingZero:
      'Das Feld muss eine 5-stellige Zahl sein, die mit einer führenden Null beginnt (z.B. 01234).',
    reverseCharge:
      'Bei ausländischen Kunden mit gültiger UmsatzsteuerID darf die Umsatzsteuer nur 0% betragen.',
    taxesAllSame: 'Es müssen alle Steuersätze in den Rechnungspositionen identisch sein.',
    ustidKey: 'Für den gewählten Steuersatz muss der Kunde eine gültige UST-ID besitzen.',
    ustidKey45:
      'Bei Umsatzsteuerschlüssel 45 darf das Land nicht Deutschland sein und es darf keine USt-IdNr. angegeben werden.'
  },
  formikErrors: {
    labelMarkREADY:
      'Diese Felder müssen ausgefüllt werden, damit die Rechnung als "Bereit" markiert werden kann.',
    labelMarkAPPROVE:
      'Diese Felder müssen ausgefüllt werden, damit die Rechnung freigegeben werden kann.',
    keys: {
      customerVersionId: 'Kunde',
      expertContactVersionId: 'Ansprechpartner',
      bankAccount: 'Bankkonto',
      paymentTarget: 'Zahlungsziel',
      reminderKey: 'Mahnschlüssel',
      invoiceDate: 'Rechnungsdatum',
      revenueTypeVersionId: 'Erlösarten',
      invoiceArticles: 'Rechnungspositionen',
      costBearer: 'Kostenträger',
      costCentre: 'Kostenstelle',
      chapter: 'Kapitel',
      title: 'Titel',
      departmentVersionId: 'Abteilung',
      additionalRecipients: 'Zusätzliche E-Mail-Empfänger',
      insArt: 'Ins/A-Art',
      customer: {
        firstName: 'Kunden-Vorname',
        lastName: 'Kunden-Nachname',
        email: 'Kunden-Email',
        zip: 'Kunden-PLZ',
        city: 'Kunden-Stadt',
        address: 'Kunden-Straße',
        country: 'Kunden-Land',
        ustId: 'Kunden-UST-ID',
        phone: 'Kunden-Telefonnummer',
        companyName: 'Kunden-Firmenname',
        customerId: 'Kunden-ZP-ID'
      }
    }
  },
  tabs: {
    all: 'Alle',
    open: 'Offene',
    closed: 'Geschlossen',
    drafts: 'Entwürfe',
    archived: 'Archiviert'
  },
  filter: {
    deniedInvoiceFilter: 'Abgelehnte Rechnungen anzeigen'
  },
  dialogs: {
    denyInvoiceTitle: 'Rechnung ablehnen',
    denyInvoiceMessage: 'Bitte geben Sie einen Grund für das Ablehnen der Rechnung an:'
  },
  alerts: {
    loadingError: 'Die Rechnung konnte nicht geladen werden.',
    pdfLoadingError: 'Die PDF-Vorschau konnte nicht geladen werden.',
    successfulInvoiceCreate: 'Die Rechnung wurde erstellt.',
    successfulInvoiceUpdate: 'Die Rechnung wurde bearbeitet.',
    failedInvoiceCreate: 'Die Rechnung konnte nicht erstellt werden.',
    failedInvoiceUpdate: 'Die Rechnung konnte nicht bearbeitet werden.',
    invoiceDeniedText: 'Die Rechnung wurde aus folgendem Grund abgelehnt: {{reason}}',
    invoiceDeniedWithoutReason: 'Die Rechnung wurde abgelehnt'
  },
  invoiceCreate: {
    title: 'Rechnung erstellen',
    customerId: 'ZP-ID',
    customerIdTooltip:
      'Die Zahlungspartner-ID kann nur über den Kundenimport gesetzt werden. Wenn ein neuer Kunde erstellt wird, wird sie automatisch auf 0 gesetzt.',
    invoiceDate: 'Rechnungsdatum',
    bankAccount: {
      stok: 'Staatsoberkasse',
      sparkasse: 'Sparkasse'
    },
    customerWrite: 'Sollen die Kundendaten beim Kunden hinterlegt werden?',
    saveCustomerInfo: 'Achtung, Sie überschreiben nun dauerhaft die hinterlegten Kundendaten.'
  },
  invoiceStateChip: {
    incompleteTooltip:
      'Die Rechnung ist unvollständig. Bitte überprüfen sie diese in der Detailansicht.'
  },
  detail: {
    details: 'Details',
    paymentTarget: '{{target}} Tage',
    paymentTargetNow: 'sofort',
    reminderKey: 'Mahnschlüssel',
    costFields: 'Kostenfelder',
    chapter: 'Kapitel',
    title: 'Titel',
    costBearer: 'Kostenträger',
    costCentre: 'Kostenstelle',
    insArt: 'Ins/A-Art',
    expertContact: 'Ansprechpartner (TH-intern)',
    department: 'Abteilung / Fakultät (TH intern)',
    additionalRecipients: 'Zusätzliche E-Mail-Empfänger',
    articles: {
      existing: 'Vorhandene Artikel',
      confirmDelete: 'Wollen Sie die Rechnungsposition wirklich löschen?',
      noArticles: 'Noch keine Rechnungspositionen'
    },
    servicePeriod: 'Leistungszeitraum',
    yourReference: 'Ihr Zeichen (Kundenreferenz)',
    revenueType: 'Erlösart',
    markAsReady: 'Für Freigabe bitte klicken',
    markedAsReady: 'An Finanzabteilung übermittelt',
    pdfPreview: 'Rechnungsvorschau',
    editModeTitle: 'Bearbeitungsmodus',
    editModeMessage:
      'Bitte den Bearbeitungsmodus verlassen, wenn die Daten fertig eingegeben wurden. Alle Änderungen werden sofort übernommen.',
    readyForApprovalTitle: 'Rechnungsentwurf vollständig',
    readyForApprovalMessage:
      'Um die Rechnung für die Finanzabteilung sichtbar zu machen, müssen Sie diese als Bereit markieren.'
  },
  noInvoiceNumberInDraftState: 'Entwurf',
  noBookingCodeInDraftState: 'Entwurf',
  noOptions: 'Keine Kunden gefunden.',
  typeToSearch: 'Tippen um zu suchen...',
  tooltips: {
    defaultTaxChanged: 'Die Standardsteuer wurde geändert.',
    moreThanOneTax:
      'Die Rechnung hat Positionen mit verschiedenen Steuersätzen. Die Rechnung wird daher bei "Als Bereit markieren" in mehrere Rechnungen aufgeteilt.',
    isFreeTextArticle: 'Das ist ein selbsterstellter Artikel.',
    hasFreeTextArticle: 'Die Rechnung enthält Positionen mit selbsterstellten Artikeln.',
    foreignTaxNotNull: 'Steuersatz entspricht nicht der Regelung für ausländische Zahlungspartner.',
    costCentre: 'Für Rechnungen mit Kostenstelle bitte an die Finanzabteilung wenden',
    departmentsCanOnlyBeChangedByAdmin:
      'Die Inhalte der Abteilungen/Fakultäten können nur von Rechnungsersteller-Administratoren gepflegt werden',
    additionalRecipients:
      'Die hier angegebenen Empfänger werden beim Versand der Rechnung in CC gesetzt. Sie werden nicht separat auf der Rechnung dargestellt. Bestätigen Sie die Eingabe mit der Eingabetaste (Enter).'
  },
  importErrors: {
    gotItButton: 'Verstanden',
    title: 'Hinweise in Rechnungen',
    subTitleErrors: 'Fehler in Rechnungen',
    subTitleWarnings: 'Warnungen in Rechnungen',
    notCreatedInvoices: 'Es konnten {{number}} Rechnungen nicht erstellt werden.',
    invoiceErrorTitle: 'Die Rechnung in Zeile {{position}} weist folgende Probleme auf:',
    invoiceDataTitle: 'Fehler in Rechnungsdaten:',
    invoiceDataWarningTitle: 'Warnungen in Rechnungsdaten:',
    invoiceDate:
      'Das Rechnungsdatum muss in einem der folgenden Formate angegeben werden: YYYY-MM-DD oder DD.MM.YYYY.',
    servicePeriodStart:
      'Das Startdatum des Leistungszeitraums muss in einem der folgenden Formate angegeben werden: YYYY-MM-DD oder DD.MM.YYYY.',
    servicePeriodEnd:
      'Das Enddatum des  Leistungszeitraums muss in einem der folgenden Formate angegeben werden: YYYY-MM-DD oder DD.MM.YYYY.',
    paymentTarget:
      'Das Zahlungsziel muss einen der folgenden Werte haben: sofort, 0d, 14d, 30d, 60d, 90d.',
    salesTaxKey:
      'Der angegebene Umsatzsteuerschlüssel entspricht keinem der im Zielsystem hinterlegten Werte.',
    bankAccount: 'Das Bankkonto muss einen der folgenden Werte haben STOK, Sparkasse.',
    revenueTypeMore: 'Es wurde mehr als ein Erlöskonto mit der Nummer gefunden.',
    revenueType: 'Das Erlöskonto ist nicht im Zielsystem hinterlegt.',
    creator: 'Die angebene UID für den Ersteller existiert nicht im System.',
    expert: 'Die angebene UID des Ansprechpartner existiert nicht im System.',
    costBearer: 'Kostensträger wurde nicht angegeben.',
    costBearerOnlyNumber: 'Kostenträger darf nur Zahlen enthalten.',
    costCentre: 'Kostenstelle darf nur Zahlen enthalten.',
    costBeaererOrCostCentre:
      'Eines von beiden Feldern muss ausgefüllt sein: Kostenträger, Kostenstelle',
    customerTitle: 'Fehler in Kundendaten:',
    customerTitleWarnings: 'Warnungen in Kundendaten:',
    customerFirstName: 'Der Vorname des Kunden wurde nicht angegeben.',
    customerLastName: 'Der Nachname des Kunden wurde nicht angegeben.',
    customerPhone: 'Die angegebene Telefonnummer ist ungültig.',
    customerEmail: 'Die angegebene Email ist ungültig.',
    customerCompanyName: 'Der Firmenname des Kunden wurde nicht angegeben.',
    customerCity: 'Die Stadt in der Addresse des Kunden wurde nicht angegeben.',
    customerAddress: 'Die Straße des Kunden wurde nicht angegeben.',
    customerCountry: 'Das Land des Kunden muss dem ISO 3166Alpha2 Format entsprechen.',
    customerVatNumber: 'Die Ust-IdNr. des Kunden ist nicht gültig',
    articleTitle: 'Fehler in Artikel {{position}}: ',
    articleTitleWarning: 'Warnungen in Artikel {{position}}: ',
    firstArticle: 'Der erste Artikel muss immer angegeben werden.',
    articleName: 'Der Name des Artikels wurde nicht angegeben.',
    articleDescription: 'Die Beschreibung des Artikels wurde nicht angegeben.',
    articleAmount: 'Die Anzahl muss größer als 0 sein',
    articleUnit:
      'Die Einheit des Artikels muss einen der folgenden Werte haben: LE, St, Std, Min, kg, km, m, m2.',
    articlePrice: 'Der Preis des Artikels wurde nicht angegeben.',
    oneArticleMustBeSet: 'Der Upload muss mindestens einen vollständigen Artikel enthalten',
    yourReferenceTooLong: 'Das Referenzfeld darf maximal 12 Zeichen lang sein.',
    reverseChargeHint:
      'Bei ausländischen Kunden mit gültiger Ust-ID muss die Umsatzsteuer 0% betragen. Bitte wählen Sie einen der folgenden Umsatzsteuerschlüssel für die Rechnung: 00, 41 oder 21.',
    generalError: 'Zu folgendem Wert sind Probleme aufgetreten: {{value}}',
    department: 'Die angegebene Abteilung wurde nicht im Zielsystem gefunden.',
    departmentFormat: 'Die Abteilung muss im folgenden Format angegeben werden Name_Email',
    chapterFormat:
      'Das Kapitel muss mit einer 0 beginnen und genau vier weitere Ziffern enthalten (z. B. 01234).',
    additionalRecipients:
      'Zusätzliche E-Mail-Empfänger benötigen ein gültiges E-Mail-Format und werden mit Komma getrennt angegeben.',
    salesTaxKey45:
      'Bei Umsatzsteuerschlüssel 45 darf das Land nicht Deutschland sein und es darf keine USt-IdNr. angegeben werden.',
    warnings: {
      ZPIDNotFound:
        'Die Zahlpartner-ID wurde nicht im Zielsystem gefunden. Das System versucht, den Kunden über die Adresse zuzuordnen. Schlägt dies fehl, so wird die Rechnung mit der Zahlpartner-ID 0 erstellt und so im Zielsystem verbucht.',
      firstNameNotSame:
        'Der im Zielsystem hinterlegte Kunde beinhaltet einen abweichenden Vornamen.',
      lastNameNotSame:
        'Der im Zielsystem hinterlegte Kunde beinhaltet einen abweichenden Nachnamen.',
      emailNotSame:
        'Der im Zielsystem hinterlegte Kunde beinhaltet eine abweichende E-Mail-Adresse.',
      phoneNotSame:
        'Der im Zielsystem hinterlegte Kunde beinhaltet eine abweichende Telefonnummer.',
      companyNameNotSame:
        'Der im Zielsystem hinterlegte Kunde beinhaltet einen abweichenden Firmennamen.',
      cityNotSame: 'Der im Zielsystem hinterlegte Kunde beinhaltet eine abweichende Stadt.',
      countryNotSame: 'Der im Zielsystem hinterlegte Kunde beinhaltet ein abweichendes Land.',
      addressNotSame: 'Der im Zielsystem hinterlegte Kunde beinhaltet eine abweichende Adresse.',
      zipNotSame: 'Der im Zielsystem hinterlegte Kunde beinhaltet eine abweichende Postleitzahl.',
      articleAmountLessThan1: 'Für einen Artikel wurde die Menge 0 angegeben.',
      ustIdNotSame: 'Der im Zielsystem hinterlegte Kunde beinhaltet eine abweichende Ust-ID.',
      foreignCompanyTaxNotNull:
        'Bei ausländischen Kunden mit gültiger Ust-ID sollte die Umsatzsteuer 0% betragen. Daher sollten Sie in Ihrer Rechnung am besten folgende Umsatzsteuerschlüssel verwenden: 00, 41 oder 21. In Ausnahmefällen ist auch der Umsatzsteuerschlüssel 81 sinnvoll.'
    }
  }
};

export default de;
export type InvoiceTranslation = typeof de;
